import React from 'react';
import ReactDOM from 'react-dom';
import { withElements } from 'with-elements';
import PracticeJerseyOrder  from './components/PracticeJerseyBuilder';

// Function to initialize the React app inside a specific container
function renderAppInElement(container) {
  console.log('RENDERING APP IN ELEMENT', container)
  ReactDOM.render(
    <React.StrictMode>
      <PracticeJerseyOrder />
    </React.StrictMode>,
    container
  );
}


withElements('.practice-jersey-container', async (element) => {
  //get the data from the elements
  document.addEventListener('DOMContentLoaded', () => {
    renderAppInElement(element);
  });
});
